import { render, staticRenderFns } from "./Ajax-94-95-Home.vue?vue&type=template&id=349057fc&"
import script from "./Ajax-94-95-Home.vue?vue&type=script&lang=js&"
export * from "./Ajax-94-95-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports